import { ref } from "vue";

export  function useDebouncedSearch(callback: (query: string) => void, delay = 1000) {
  const loading = ref(false);
  let debounceTimer: ReturnType<typeof setTimeout> | null = null;

  const remoteMethod = (query: string) => {
    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      if (query) {
        loading.value = true;
        callback(query);
        setTimeout(() => {
          loading.value = false;
        }, 200);
      }
    }, delay);
  };

  return { remoteMethod, loading };
}